/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useContext, useState, useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  initialQueryState,
  PaginationState,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { getReview } from './_requests'
import { Review } from './_models'
import { useQueryRequest } from './QueryRequestProvider'
import { Response as oResponse } from '../../../../../../_metronic/helpers'
import { getQueryStringValues } from '../../../../../../_metronic/helpers/utility'

const QueryResponseContext = createResponseContext<Review>(initialQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { state, updateState } = useQueryRequest()
  const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
  const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

  useEffect(() => {
    var items_per_page_parsed = 30 as 10 | 30 | 50 | 100 | undefined
    var page_parsed = 1
    var filter_channel_parsed = ""
    var filter_sourcetype_parsed = ""
    var filter_channeltype_parsed = ""
    var filter_subject_parsed = ""
    var filter_date_parsed = ""
    var filter_language_parsed = ""
    var filter_country_parsed = ""

    var items_per_page = getQueryStringValues(window.location.search).get('items_per_page')
    if (items_per_page !== null && items_per_page !== undefined && ["10", "30", "50", "100"].indexOf(items_per_page as string) > -1) {
      items_per_page_parsed = parseInt(items_per_page as string) as 10 | 30 | 50 | 100 | undefined
    }

    var page = getQueryStringValues(window.location.search).get('page')
    if (page !== null && page !== undefined && page !== "") { page_parsed = parseInt(page as string) }

    var filter_channel = getQueryStringValues(window.location.search).get('filter_channel')
    if (filter_channel !== null && filter_channel !== undefined && filter_channel !== "") { filter_channel_parsed = filter_channel as string }

    var filter_sourcetype = getQueryStringValues(window.location.search).get('filter_sourcetype')
    if (filter_sourcetype !== null && filter_sourcetype !== undefined && filter_sourcetype !== "") { filter_sourcetype_parsed = filter_sourcetype as string }

    var filter_channeltype = getQueryStringValues(window.location.search).get('filter_channeltype')
    if (filter_channeltype !== null && filter_channeltype !== undefined && filter_channeltype !== "") { filter_channeltype_parsed = filter_channeltype as string }

    var filter_subject = getQueryStringValues(window.location.search).get('filter_subject')
    if (filter_subject !== null && filter_subject !== undefined && filter_subject !== "") { filter_subject_parsed = filter_subject as string }

    var filter_date = getQueryStringValues(window.location.search).get('filter_date')
    if (filter_date !== null && filter_date !== undefined && filter_date !== "") { filter_date_parsed = filter_date as string }

    var filter_language = getQueryStringValues(window.location.search).get('filter_language')
    if (filter_language !== null && filter_language !== undefined && filter_language !== "") { filter_language_parsed = filter_language as string }

    var filter_country = getQueryStringValues(window.location.search).get('filter_country')
    if (filter_country !== null && filter_country !== undefined && filter_country !== "") { filter_country_parsed = filter_country as string }

    updateState({ ...state, ...{ items_per_page: items_per_page_parsed, page: page_parsed, filter: { channel: filter_channel_parsed, channeltype: filter_channeltype_parsed, subject: filter_subject_parsed, date: filter_date_parsed, sourcetype: filter_sourcetype_parsed, language: filter_language_parsed, country: filter_country_parsed,  }, } })
  }, [])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  let {
    isFetching,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.REVIEW_LIST}-${query}`,
    () => {
      return getReview(query)
    },
    { cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false }
  )

  const parsedResponse = useMemo(() => {
    if (response === undefined) {
      return undefined
    }

    const result = JSON.parse(JSON.stringify(response)).result
    if (result === undefined) {
      return undefined
    }

    try {
      return { data: result.data, payload: result.payload } as oResponse<Review[]>
    } catch (ex) {
      console.log('QueryResponseProvider.useMemo.ex: ', JSON.stringify(ex))
      return undefined
    }
  }, [response])

  return (
    <QueryResponseContext.Provider value={{ isLoading: isFetching, refetch, response: parsedResponse, query }}>
      {children}
    </QueryResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryResponseContext)

const useQueryResponseData = () => {
  const { response } = useQueryResponse()
  if (!response) {
    return []
  }

  return response?.data || []
}

const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const { response } = useQueryResponse()
  if (!response || !response.payload || !response.payload.pagination) {
    return defaultPaginationState
  }

  // console.log("response.payload.pagination", response.payload.pagination)
  return response.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const { isLoading } = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
